import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const Tweet18 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={18}
    contrast={contrast}
    className={className}
  >
    <g clipPath='url(#clip0_1_723)'>
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M2.15006 2.7895L2.14971 2.7907C1.97872 3.38043 1.92259 4.01773 1.93251 4.62843C1.94322 5.28783 2.05379 6.08762 2.40857 6.87H0.999912C0.466263 6.87 0.0976238 7.43791 0.314877 7.92533C0.786276 8.98296 1.50715 9.91048 2.41569 10.6284C2.93779 11.0409 3.51291 11.3771 4.12366 11.6291C3.38007 12.1661 2.55928 12.5917 1.68694 12.8904C1.1092 13.0883 1.00716 13.8897 1.5169 14.226C3.02473 15.2208 4.79154 15.7507 6.59792 15.75C7.79301 15.7568 8.97776 15.5282 10.0845 15.0771C11.192 14.6258 12.1997 13.9605 13.0499 13.1194C13.9001 12.2783 14.5762 11.2778 15.0395 10.1752C15.6044 8.83076 15.7499 7.43999 15.7499 6L17.9999 3L15.1015 3.72461C13.8696 1.97714 11.2144 1.73508 9.68968 3.25977C9.20552 3.74394 8.87565 4.35356 8.73172 5.01222C7.8065 4.96348 6.89498 4.75547 6.03772 4.39583C5.05433 3.92298 4.16519 3.27502 3.41382 2.48361C3.02288 2.07183 2.30942 2.24453 2.15006 2.7895ZM10.7503 4.32043C11.5399 3.5309 12.8599 3.5309 13.6495 4.32043C14.0339 4.70488 14.2499 5.22631 14.2499 5.77C14.2499 7.08855 14.1767 8.35634 13.6566 9.59417C13.2697 10.515 12.7051 11.3506 11.995 12.053C11.2849 12.7555 10.4433 13.3111 9.51838 13.6881C8.59342 14.0651 7.60322 14.256 6.60441 14.25L6.59941 14.25C5.58711 14.2507 4.58961 14.0523 3.66198 13.6715C4.58618 13.1906 5.43864 12.5774 6.19143 11.849C6.62035 11.434 6.39509 10.6832 5.80854 10.5729C4.90896 10.4037 4.06384 10.0189 3.34564 9.45142C2.94895 9.13797 2.59752 8.77397 2.29958 8.37H3.79991C4.44344 8.37 4.78713 7.57493 4.34624 7.10616C3.62964 6.34426 3.43281 5.35927 3.43162 4.52578C4.04094 5.00704 4.70302 5.42012 5.40623 5.75656C5.41679 5.76161 5.42747 5.76642 5.43826 5.77097C6.69699 6.30226 8.05497 6.55757 9.42069 6.51972C9.82666 6.50846 10.1499 6.17612 10.1499 5.77C10.1499 5.22631 10.3659 4.70488 10.7503 4.32043Z'
        fill='currentColor'
      />
    </g>
    <defs>
      <clipPath id='clip0_1_723'>
        <rect width='18' height='18' fill='white' />
      </clipPath>
    </defs>
  </Svg>
);

Tweet18.displayName = 'Tweet18';
export default Tweet18;
